<mat-card>

  <div *ngFor="let phase of phases">
    {{phase}}
    <div *ngIf="phase == 'Plan'">      
    </div>
  </div>

</mat-card>